import React from 'react'
import styled from 'styled-components'

const PoweredByLogo = styled.div`
  ${'' /* color: ${props => props.theme.colors.text.inputPlaceholder}; */}
  color: ${props => props.theme.colors.text.input};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  display: flex;
  align-items: center;
  padding: 0 0 .2rem 0;
`

const PoweredBy = (props) => {
  return (
    <PoweredByLogo>
      Powered by
    </PoweredByLogo>
  )
}

export default PoweredBy
